import * as React from 'react';
import { styled } from 'styled-components';
import Tooltip, { TooltipProps, tooltipClasses } from '@mui/material/Tooltip';

const StyledTooltip = styled(({ className, ...props }: TooltipProps) => (
  <Tooltip {...props} classes={{ popper: className }} />
))(({ theme }) => ({
  [`& .${tooltipClasses.tooltip}`]: {
    backgroundColor: theme.secondaryButtonBackground, // Dark mode or custom color
    color: theme.color, // Text color based on mode

    display: 'flex',
    padding: ' 4px 8px 6px 8px',
    boxShadow: '0px 2px 4px 0px rgba(0, 0, 0, 0.25)',
    alignItems: 'flex-start',
    gap: 8,
    fontFamily: 'Aeonik',
    fontSize: 16,
    fontStyle: 'normal',
    fontWeight: 500,

  },
  [`& .${tooltipClasses.arrow}`]: {
    color: theme.secondaryButtonBackground,
  },
}));

interface CustomizedTooltipsProps {
  children: React.ReactElement;
  title: React.ReactNode;
  isByComparison?: boolean

}

const CustomizedTooltips: React.FC<CustomizedTooltipsProps> = ({ children, title , isByComparison }) => {
  // Ensure children are React elements
  if (!React.isValidElement(children)) {
    throw new Error("Children must be valid React elements");
  }

  return (
    <div style={isByComparison ? {position : 'absolute'} : {}}>
      <StyledTooltip title={title} placement="top" arrow enterDelay={500} enterNextDelay={500}>
        {children}
      </StyledTooltip>
    </div>
  );
}

export default CustomizedTooltips;